var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._g({staticClass:"sam-label__wrapper",attrs:{"id":_vm.labelId,"data-samora":""}},_vm.$listeners),[_c('div',{class:[
      `sam-label is-${_vm.samStyle}`,
      { 'is-subtle': _vm.subtle && !_vm.loading },
      { 'is-loading': _vm.loading },
      { 'is-icon': _vm.isIconOnly },
      { 'hide-value': _vm.showOnHover }
    ],attrs:{"data-testid":"sam-label__content"}},[(_vm.icon)?_c('SamIcon',_vm._b({staticClass:"sam-label__icon",attrs:{"icon":_vm.icon,"size":12}},'SamIcon',_vm.iconProps,false)):_vm._e(),(_vm.value)?_c('span',{staticClass:"sam-label__text"},[_vm._v(" "+_vm._s(_vm.value)+" ")]):_vm._e()],1),(_vm.hasTooltip)?_c('SamTooltip',{attrs:{"message":_vm.tooltipValue,"position":'top',"anchor-name":_vm.labelId}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }